import 'whatwg-fetch'
import { api, googleMaps, basicPayload, withPersistentCart } from 'config'
import CartService from 'services/Cart/'
import StorageService from 'services/StorageService/'
import CartAction from 'actions/Cart'
import PubSub from 'services/PubSub/'
import SalesChannel from 'services/SalesChannel'
import { actionsType, productsSimulation } from 'config/constants'
import { updateTabs } from 'utils'
import PersistentCart from "services/PersistentCart";
import {cleanAddress } from 'utils';

let promise = {
    all: null,
    simulationDelivery: null
}

const getGeocode = (address) => {
    return fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&components=country:CL&key=${googleMaps.apiWithoutRestrictions}`)
        .then(results => results.json())
        .then(data => (data && data.results && data.results.length) ? data.results[0] : false)
}

const getAll = () => {
    if (promise.all) {
        return Promise.resolve(promise.all)
    }

    const token = StorageService.getItem('sessionData')

    promise.all = fetch(api.userAddress + `/user/address`, {
        headers: {
            'token': token,
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
        },
    }).then(results => results.json())
        .then(results => {
            promise.all = null
            if (results && results.status === 401) {
                CartAction.logout(() => {
                    CartAction.logoutRedirect()
                })
            }
            return results.filter(address => address.addressId.indexOf(',') === -1 && address.addressId.indexOf(' ') === -1);
        })

    return promise.all
}

const _addAddress = (address, updating = false) => {
    const token = StorageService.getItem('sessionData')

    return fetch(api.userAddressV2 + `/user/address${updating ? ('/' + address.addressId) : ''}`, {
        method: updating ? 'PUT' : 'POST',
        headers: {
            'token': token,
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(address),
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}

const addAddress = (address) => {
    return _addAddress(address)
}

const updateAddress = (address) => {
    return _addAddress(address, true)
}

const remove = (id) => {
    const token = StorageService.getItem('sessionData')

    return fetch(api.userAddress + `/user/address/${id}`, {
        method: 'DELETE',
        headers: {
            'token': token,
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
        },
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}

const getSalesChannel = (lat, lng) => {
    return fetch(api.salesChannelV2 + `/sales-channel/geolocation?lat=${lat}&lng=${lng}`, {
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
        },
    }).then(results => results.json())
        .catch((e) => {
            /* eslint-disable no-console */
            console.log(e, 'getSaleChannel')
            /* eslint-disable no-console */
            //PubSub.dispatch('error_503');
            return false
        })
}

const setSalesChannel = (sc) => {
    SalesChannel.setSalesChannel(sc)
}

const applyAddress = (address, availableAddresses = [], method = null, SC = null) => {
    address.postalCode = address.postalCode || ''
    address.complement = cleanAddress(address.complement)
    address.reference = cleanAddress(address.reference)

    StorageService.setSecureItem('address', address)

    return CartService.getCurrentCart().then(orderForm => {
        if (!orderForm) return false
        const shippingData = orderForm.shippingData || null

        if (shippingData && shippingData.address && shippingData.address.receiverName) {
            address.receiverName = shippingData.address.receiverName
        } else {
            const userData = StorageService.getSecureItem('userData')
            address.receiverName = userData ? userData.firstName + ' ' + userData.lastName : ''
        }

        if (method && shippingData && shippingData.logisticsInfo && shippingData.logisticsInfo.length) {
            shippingData.logisticsInfo = CartService.applyingMethodInLogisticInfo(shippingData.logisticsInfo, method)
        }

        const body = {
            address,
            availableAddresses: availableAddresses,
            expectedOrderFormSections: basicPayload.expectedOrderFormSections,
            logisticsInfo: shippingData ? shippingData.logisticsInfo : [],
            pickupPoints: shippingData ? shippingData.pickupPoints : [],
            selectedAddresses: [address],
        }

        return fetch(api.orderForm + `/orderForm/${orderForm.orderFormId}/shipping${SC ? '?sc='+SC : ''}`, {
            headers: {
                'x-api-key': api.apiKey,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(body),
        }).then(results => results.json())
            .catch(() => {
                PubSub.dispatch('error_503')
                return false
            })
    })
}

const applySalesChannel = (sc, oldAddress = false, refresh = true) => {
    return CartService.applySalesChannel(sc, oldAddress, refresh)
}

const setDeliveryMode = (method, name, sc, oldAddress = false, refresh = true, urlCallback = false) => {

    SalesChannel.setOldSalesChannelInfo()

    SalesChannel.removeAll()

    SalesChannel.setMethodName(method)
    SalesChannel.setSalesChannelName(name)

    const methodTranslate = {
        'seller-1-sla-DespachoaDomicilio': 1,
        'seller-1-sla-RetiroenTienda': 2,
        'seller-1-sla-ClickalAuto': 3,
        'seller-1-sla-Express': 4,
    }

    setSalesChannel(sc)
    if(oldAddress){
        oldAddress.complement = cleanAddress(oldAddress.complement);
        oldAddress.reference = cleanAddress(oldAddress.reference);
    }

    return applySalesChannel(sc, oldAddress, refresh).then((orderForm) => {
        PubSub.dispatch('select_delivery_mode')

        if(withPersistentCart) {
            PersistentCart.setPersistentOrderForm(methodTranslate[method]).then(() => {
                if (refresh && orderForm && window) {
                    if (urlCallback) window.location.href = urlCallback;
                    else window.location.reload();
                }
            });
        }else {
            if(refresh && urlCallback) window.location.href = urlCallback;
        }

        return orderForm
    })
}

const newSetDeliveryMode = (method, name, sc, refresh = true, address = false, applyAddressSelected = true, applyShippingData = true) => {
    SalesChannel.setOldSalesChannelInfo()
    if (!address && (method === 'seller-1-sla-RetiroenTienda' || method === 'seller-1-sla-ClickalAuto')) {
        address = {
            'addressType': 'residential',
            'receiverName': '',
            'postalCode': '8320000',
            'city': 'Santiago',
            'state': 'REGIÓN METROPOLITANA',
            'country': 'CHL',
            'street': 'Avenida Presidente Kennedy',
            'number': '9001',
            'neighborhood': 'Santiago',
            'complement': '',
            'reference': '',
            'geoCoordinate': [-70.5462013, -33.3908833],
            'addressId': 'q9f6zuh4v3fcfsnwc9mkm1563398193834',
            'geoCoordinates': [-70.5462013, -33.3908833],
        }
    }

    SalesChannel.removeAll()
    SalesChannel.setMethodName(method)
    SalesChannel.setSalesChannelName(name)
    address.postalCode = address.postalCode || ''
    address.complement = cleanAddress(address.complement);
    address.reference = cleanAddress(address.reference);

    const oldAddress = StorageService.getSecureItem('address');
    StorageService.setSecureItem('address', address)
    const methodTranslate = {
        'seller-1-sla-DespachoaDomicilio': 1,
        'seller-1-sla-RetiroenTienda': 2,
        'seller-1-sla-ClickalAuto': 3,
        'seller-1-sla-Express': 4,
    }

    setSalesChannel(sc)
    StorageService.removeItem('sc_validate')

    return CartService.applyAddressSC(address, sc, refresh, method, applyShippingData, oldAddress).then((orderForm) => {
        if (orderForm && applyAddressSelected && address && address.addressId) {
            StorageService.setItem('addressSelected', address.addressId)
        }

        if(!withPersistentCart){
            if (refresh && orderForm && window) {
                setTimeout(() => PubSub.dispatch(actionsType.SET_SALES_CHANNEL, sc), 0);
                updateTabs();
            }
            return orderForm;
        }

        return PersistentCart.setPersistentOrderForm(methodTranslate[method]).then(() => {
            if (refresh && orderForm && window) {
                setTimeout(() => PubSub.dispatch(actionsType.SET_SALES_CHANNEL, sc), 0);
                updateTabs();
            }
            return orderForm
        })
    })
}

const getDeliveryMode = (sellerId) => {
    return SalesChannel.getMethodName(sellerId);
}

const getStoreName = () => {
    return StorageService.getItem('store_name') || 'Jumbo Chile'
}

const getAnonymousAdresses = () => {
    return StorageService.getSecureItem('anonymous_address')
}

const clearAnonymousAdresses = () => {
    StorageService.removeSecureItem('anonymous_address')
}

const getSelectedAdress = () => {
    return StorageService.getSecureItem('address')
}

const getFullAddress = (address) => {
    let addressArray = []

    addressArray.push(address.street + ' ' + (address.number || ''))
    if (address.complement) addressArray.push(address.complement)
    addressArray.push(address.neighborhood)
    addressArray.push(address.city)
    addressArray.push(address.state)

    return addressArray.join(', ')
}

const _getDistance = (lng1, lat1, lng2, lat2) => {
    if (typeof (Number.prototype.toRad) === 'undefined') {
        Number.prototype.toRad = function() {
            return this * Math.PI / 180
        }
    }

    var R = 6371 // Radius of the earth in km
    var dLat = (lat2 - lat1).toRad()  // Javascript functions in radians
    var dLon = (lng2 - lng1).toRad()
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c // Distance in km
    return d
}

const getAddressDistance = (point1, point2) => {
    return _getDistance(point1.lng(), point1.lat(), point2.lng(), point2.lat())
}

const getLogisticSimulation = (address, sc, shippingMethod) => {
    const location = {
        zipCode: address ? address.postalCode : null,
        country: 'CHL',
        point: address ? address.geoCoordinate : [-70.6344083, -33.4475487],
    }


    const body = {
        location,
        saleschannel: sc,
        shippingMethod: shippingMethod,
        items: productsSimulation,
        isCart: true,
    }

    return fetch(api.salesChannel + `/shipping/simulation`, {
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(body),
    }).then(results => results.json()).then(results => {
        if (results && results.data && (!results.data.isAvailable) && (shippingMethod === 'Despacho a Domicilio')) {
            return getLogisticSimulation(address, sc, 'Despacho Especial')
        }
        return results
    })
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}

const getHoursDelivery = (address, sc, shippingMethod) => {
    if(!(sc && shippingMethod)) return Promise.resolve(false);
    if(promise.simulationDelivery) return promise.simulationDelivery;

    let geoCoordinate = null;
    if(address){
        geoCoordinate =address.geoCoordinate ? address.geoCoordinate : address.geoCoordinates;
    }
    const location = {
        zipCode: address ? address.postalCode : null,
        country: 'CHL',
        point: geoCoordinate ? geoCoordinate : [-70.6344083, -33.4475487],
    }
    let products = null;

    promise.simulationDelivery = CartService.getCurrentCart().then(orderForm => {

        if(orderForm && orderForm.items){
            products = orderForm.items.map(product => {
                return {
                    idSku: product.id,
                    price: product.sellingPrice * product.quantity,
                    quantidade: product.quantity
                }
            })
        }

        if(!(products && products.length) || orderForm.value < 1000000) {
            products = productsSimulation

        }

        const body = {
            location,
            saleschannel: sc,
            shippingMethod: shippingMethod,
            items: products,
            isCart: true,
        }

        return fetch(api.salesChannel + `/shipping/simulation/delivery`, {
            headers: {
                'x-api-key': api.apiKey,
                'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify(body),
        }).then(results => results.json()).then(results => {
            promise.simulationDelivery = null;
            if (results && results.data && (!results.data.isAvailable) && (shippingMethod === 'Despacho a Domicilio')) {
                return getHoursDelivery(address, sc, 'Despacho Especial')
            }
            return results
        });
    }).catch(() => {
        promise.simulationDelivery = null;
        PubSub.dispatch('error_503')
        return false
    })

    return promise.simulationDelivery;

}
const getSlasSimulation = (address, sc, shippingMethod, items) => {
    const location = {
        zipCode: address ? address.postalCode : null,
        country: 'CHL',
        point: address ? address.geoCoordinate : [-70.6344083, -33.4475487],
    }
    let products = items;

    if(!(products && products.length)) {
        products = productsSimulation

    }

    const body = {
        location,
        saleschannel: sc,
        shippingMethod: shippingMethod,
        items: products,
        isCart: true,
    }

    return fetch(api.salesChannel + `/shipping/simulation/deliveryAll`, {
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(body),
    }).then(results => results.json()).then(results => {
        if (results && results.data && (!results.data.isAvailable) && (shippingMethod === 'Despacho a Domicilio')) {
            return getSlasSimulation(address, sc, 'Despacho Especial')
        }
        return results
    })
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}

const validateAddress = (id, code) => {
    const token = StorageService.getItem('sessionData')
    let authenticationToken = StorageService.getItem('tokenEmail')

    const body = {
        "accessKey": code,
        "authenticationToken": authenticationToken
    }

    return fetch(api.userAddress + `/user/address/validate/${id}`, {
        method: 'POST',
        headers: {
            'token': token,
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}

const AddressService = {
    getGeocode,
    getAll,
    addAddress,
    updateAddress,
    remove,
    getSalesChannel,
    applyAddress,
    setDeliveryMode,
    getAddressDistance,
    newSetDeliveryMode,
    getDeliveryMode,
    getStoreName,
    getAnonymousAdresses,
    clearAnonymousAdresses,
    getSelectedAdress,
    getFullAddress,
    getLogisticSimulation,
    getHoursDelivery,
    getSlasSimulation,
    validateAddress
}

export default AddressService
